import { useTranslator } from '@Localization';
import { Input } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, ReactElement, useEffect, useState } from 'react';
import { drawingScreenDisables, keyboardShortcutsServiceInstance } from '../../../../services/keyboardShortcuts.service';
import { ITextAnswerProps } from '../../question.model';

export const NumericAnswer = observer((props: ITextAnswerProps): ReactElement => {
  const [answer, setAnswer] = useState<string | undefined>(props.answer);
  const { t } = useTranslator();

  useEffect(() => {
    setAnswer(props.answer);
  }, [props.answer]);

  const handleFocus = (): void => {
    keyboardShortcutsServiceInstance.disableShortcuts(drawingScreenDisables);
  };

  const handleBlur = (): void => {
    keyboardShortcutsServiceInstance.enableShortcuts(drawingScreenDisables);
    props.onAnswered(answer || '');
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value.trim();
    const parsed = Number(value.endsWith('.') ? value + '0' : value);
    if (!value || value === '-' || !Number.isNaN(parsed)) {
      setAnswer(value);
    } else {
      e.preventDefault();
    }
  };

  return (
    <Input
      type='text'
      slotProps={{
        input: {
          tabIndex: 1,
        },
      }}
      className={props.className}
      value={answer}
      placeholder={t('open_answer_placeholder')}
      onChange={handleChange}
      disabled={props.disabled}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
});
